(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty-discounts"] && !Shopify.designMode) return;
  try {
    
  /* Loyalty Discounts copy-to-clipboard | BY CLICKMOUSE
     One delegated listener, no global function, survives section re-renders. */
  (function () {
    if (window.__cmLoyaltyCopyBound) return;
    window.__cmLoyaltyCopyBound = true;

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      return ok ? Promise.resolve() : Promise.reject();
    }

    function copy(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).catch(function () { return fallbackCopy(text); });
      }
      return fallbackCopy(text);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-loyalty-copy]');
      if (!btn) return;
      var code = btn.getAttribute('data-loyalty-copy');
      var label = btn.querySelector('.cm-loyalty__copy-label');
      copy(code).then(function () {
        if (label) label.textContent = 'Copied!';
        btn.classList.add('is-copied');
      }, function () {
        if (label) label.textContent = 'Select & copy';
      }).then(function () {
        clearTimeout(btn.__cmTimer);
        btn.__cmTimer = setTimeout(function () {
          if (label) label.textContent = 'Copy';
          btn.classList.remove('is-copied');
        }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
